var hasUnselectedAttributes = function hasUnselectedAttributes(attributes) {
  return !!(attributes == null ? void 0 : attributes.length) && attributes.find(function (attr) {
    return !attr.selected;
  });
};
export default hasUnselectedAttributes;